export type TBrowserRuntime = {
  document?: {
    cookie?: string;
  };
  navigator?: {
    language?: string;
    languages?: readonly string[];
  };
  location?: {
    search?: string;
  };
  window?: {
    crypto?: {
      subtle?: {
        digest(
          algorithm: string,
          data: ArrayBufferView | ArrayBuffer,
        ): Promise<ArrayBuffer>;
      };
    };
  };
};

export function getBrowserRuntime(): TBrowserRuntime {
  return globalThis as typeof globalThis & TBrowserRuntime;
}

export function hasBrowserDocument(): boolean {
  return getBrowserRuntime().document !== undefined;
}

type TSearchParams = {
  get(name: string): string | null;
};

export function parseSearchParams(search: string): TSearchParams {
  const ParamsCtor = (
    globalThis as typeof globalThis & {
      URLSearchParams: new (init: string) => TSearchParams;
    }
  )['URLSearchParams'];

  return new ParamsCtor(search);
}

export function createTextEncoder(): { encode: (input: string) => Uint8Array } {
  const EncoderCtor = (
    globalThis as typeof globalThis & {
      TextEncoder: new () => { encode: (input: string) => Uint8Array };
    }
  )['TextEncoder'];

  return new EncoderCtor();
}
